module.exports = __webpack_public_path__ + "static/media/compress-alt.b0223bd4.svg";